import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebaseConfig";

export async function uploadProofImage({ file, orgId, orderId }) {
  if (!file) throw new Error("No proof file selected.");
  if (!orgId) throw new Error("Missing orgId.");
  if (!orderId) throw new Error("Missing orderId.");

  const ext = file.name?.split(".").pop() || "jpg";
  const storageRef = ref(
    storage,
    `ontime/${orgId}/proofs/${orderId}/${Date.now()}.${ext}`
  );

  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
}
